import styled from 'styled-components';

export const Img = styled.img`
  height: 100%;
  width: 100%;
  object-fit: fill;
`;
